module.exports = __webpack_public_path__ + "img/bebee.4a5a0462.svg";